/** App shell backgrounds — branded mainBg applies in light mode only */
export const DARK_SURFACE_BG = '#0F172A';
export const LIGHT_SURFACE_DEFAULT = '#FFFFFF';
export const DARK_TOPBAR_BG = '#0F172A';
export const LIGHT_TOPBAR_DEFAULT = '#FFFFFF';

export const getAppSurfaceBg = (isDarkMode, mainBgColor) =>
  isDarkMode ? DARK_SURFACE_BG : (mainBgColor || LIGHT_SURFACE_DEFAULT);

export const getAppShellTextColor = (isDarkMode, secondaryColor) =>
  isDarkMode ? '#E4E6EB' : (secondaryColor || '#1F1F1F');

/** Top bar: always white (light) or dark slate — not branded topbarColor */
export const getTopbarBg = (isDarkMode) =>
  isDarkMode ? DARK_TOPBAR_BG : LIGHT_TOPBAR_DEFAULT;

export const getTopbarTextColor = (isDarkMode) =>
  isDarkMode ? 'rgba(248, 250, 252, 0.96)' : 'rgba(15, 23, 42, 0.92)';

export const getTopbarMutedTextColor = (isDarkMode) =>
  isDarkMode ? 'rgba(203, 213, 225, 0.88)' : 'rgba(71, 85, 105, 0.78)';

export const getTopbarControlColor = (isDarkMode, primaryColor) =>
  isDarkMode ? 'rgba(248, 250, 252, 0.92)' : (primaryColor || 'rgba(15, 23, 42, 0.85)');
